import { css, styled } from 'styled-components';
import { ScOutsideArrows } from '@/components/NativeSlider/components/arrows/OutsideArrows/styled';
import { ScSectionTitle } from '@/components/SectionTitle/styled';
import { containerPadding, screen } from '@/styles/helpers';
import { MOBILE_SLIDE_GAP, MOBILE_SLIDE_WIDTH, SLIDE_GAP } from './helpers';

const slideBasis = (perView: number) => css`
  flex: 0 0 calc((100% - ${SLIDE_GAP * (perView - 1)}px) / ${perView});
`;

export const ScBonusShopSlider = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${ScSectionTitle} {
    margin-bottom: 0;
    text-transform: none;
  }

  & .slider-header {
    display: flex;
    gap: 16px;
    align-items: center;
    justify-content: space-between;
  }

  & .slider-controls {
    display: flex;
    gap: 8px;
    align-items: center;
    flex-shrink: 0;

    & button {
      text-transform: uppercase;
    }
  }

  ${ScOutsideArrows} {
    display: none;

    @media (${screen.md}) {
      display: flex;
    }
  }

  & .embla-viewport {
    overflow: hidden;
    margin-inline: -${containerPadding.base}px;
    padding-inline: ${containerPadding.base}px;

    @media (${screen.md}) {
      margin-inline: 0;
      padding-inline: 0;
    }
  }

  & .embla-container {
    display: flex;
    gap: ${MOBILE_SLIDE_GAP}px;

    @media (${screen.md}) {
      gap: ${SLIDE_GAP}px;
    }
  }

  & .embla-slide {
    flex: 0 0 ${MOBILE_SLIDE_WIDTH}px;
    min-width: 0;

    @media (${screen.md}) {
      ${slideBasis(3)}
    }

    @media (${screen.lg}) {
      ${slideBasis(4)}
    }

    @media (${screen.xxl}) {
      ${slideBasis(5)}
    }
  }
`;
